var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"online-class-home-wrap"},[_vm._m(0),_c('div',{staticClass:"class-body"},[_c('course')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"banner"},[_c('h1',[_vm._v("在线"),_c('span',[_vm._v("课堂")])]),_c('div',[_vm._v("ONLINE CLASSROOM")])])
}]

export { render, staticRenderFns }